import { get, API_URL } from 'lib/network/api';
import * as types from '../types/profileTypes';

export const fetchProfileRequest = () => ({
  type: types.FETCH_PROFILE_REQUEST,
});

export const fetchProfileSuccess = (profile) => ({
  type: types.FETCH_PROFILE_SUCCESS,
  payload: profile,
});

export const fetchProfileFailure = (error) => ({
  type: types.FETCH_PROFILE_FAILURE,
  payload: error,
});

export const fetchProfile = () => {
  return (dispatch) => {
    dispatch(fetchProfileRequest());
    get(`${API_URL}/api/user`)
      .then((response) => {
        dispatch(fetchProfileSuccess(response));
      })
      .catch((error) => {
        dispatch(fetchProfileFailure(error));
      });
  };
};
